import React from 'react'

const SettingsContext = React.createContext();

export const SettingsProvider = SettingsContext.Provider;
export const useSettings = () => React.useContext(SettingsContext);